import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'replacePlaceholders',
    standalone: true,
})
export class ReplacePlaceholdersPipe implements PipeTransform {
    transform(template: string, data: any): string {
        if (!template || !data) {
            return template;
        }
        // Replace simple placeholders (e.g., {{key}})
        let result = template.replace(/{{\s*([\w.]+)\s*}}/g, (match, key) => {
            const value = this.getValueFromKey(data, key);
            return value !== undefined ? value : match;
        });
        // Handle array placeholders
        result = result.replace(/{{#(\w+)}}([\s\S]*?){{\/\1}}/g, (match, arrayKey, content) => {
            const array = this.getValueFromKey(data, arrayKey);
            if (Array.isArray(array)) {
                return array
                    .map(item => content.replace(/{{\s*([\w.]+)\s*}}/g, (subMatch, subKey) => {
                        const value = this.getValueFromKey(item, subKey);
                        return value !== undefined ? value : subMatch;
                    }))
                    .join('');
            }
            return match;
        });
        return result;
    }
    private getValueFromKey(data: any, key: string): any {
        return key.split('.').reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), data);
    }
}
